import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title", "onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressOutput = _resolveComponent("AddressOutput")!
  const _component_DeliveryTargetOutput = _resolveComponent("DeliveryTargetOutput")!
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!

  return (_openBlock(), _createBlock(_component_ParempiGrid, {
    class: "flex-grow-1 flex-min-height-0",
    items: this.plotOrderTemplateInfos,
    columns: this.columns,
    storageKey: "plotOrderTemplateListWidget"
  }, {
    name: _withCtx(({ item }) => [
      _createElementVNode("b", null, _toDisplayString(item.name), 1)
    ]),
    templateResolver: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(this.getPlotOrderTemplateLabel(item)), 1)
    ]),
    plotter: _withCtx(({  item }) => [
      _createVNode(_component_AddressOutput, {
        address: item.plotterOrganisationAddress,
        outputCountry: false
      }, null, 8, ["address"])
    ]),
    billingAddress: _withCtx(({ item }) => [
      _createVNode(_component_AddressOutput, {
        address: item.billingAddress,
        outputCountry: false
      }, null, 8, ["address"])
    ]),
    itemCount: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(item.items.length), 1)
    ]),
    deliveryAddress: _withCtx(({ item }) => [
      _createVNode(_component_DeliveryTargetOutput, {
        items: item.items
      }, null, 8, ["items"])
    ]),
    description: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(item.description ?? ""), 1)
    ]),
    actions: _withCtx(({ item }) => [
      (this.mayEditTemplate)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-sm btn-outline-primary me-1",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('plot.template.list.edit'),
            onClick: ($event: any) => (this.editPlotOrderTemplate(item))
          }, _hoisted_3, 8, _hoisted_1))
        : _createCommentVNode("", true),
      (this.mayEditTemplate)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-sm btn-outline-danger me-1",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('plot.template.list.delete'),
            onClick: (() => {
                      return () => _ctx.deletePlotOrderTemplate(item);
                      })()
          }, _hoisted_6, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["items", "columns"]))
}